import { render } from "./terBidNoti.vue?vue&type=template&id=439d9183"
import script from "./terBidNoti.vue?vue&type=script&lang=js"
export * from "./terBidNoti.vue?vue&type=script&lang=js"

import "./terBidNoti.vue?vue&type=style&index=0&id=439d9183&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__